/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useEffect } from "react";
import _ from 'lodash';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { useCallback } from "react";
import styles from '../../BuildingSummaryAccordion.module.scss';
import metadata from './CommercialCoveragesAccordion.metadata.json';

function CommercialCoveragesAccordion(props) {
    const { data: building, index, path: buildingPath, isQuotePage, isPolicySummary } = props;

    useEffect(() => {
        if (!_.isUndefined(building)) {
            getCoverages();
        }
    }, [])
    const getCoverages = () => {
        const coverages = _.get(building, 'coverages');
        hideNonVisibleCoverageTerms(coverages);
    }
    const hideNonVisibleCoverageTerms = (cpData) => {
        const HIDE_COVTERM_NAMES = ['Valuation Method', 'Coinsurance'];
        const excludeCoverageTerms = (coverage) => {
            coverage.terms = coverage?.terms?.filter(t => !HIDE_COVTERM_NAMES.includes(t.name));
        };

        const excludedCoverages = cpData?.forEach(excludeCoverageTerms)
        return excludedCoverages;
    }

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
        },
    }

    // DE16198
    const getCoveragesToDisplay = useCallback(() => {
        const blanketCoverages = _.get(building, 'blanket_TWIA.coverages.value') !== undefined ?
            _.get(building, 'blanket_TWIA.coverages.value') : _.get(building, 'blanket_TWIA.coverages');
        const BUILDING_PROPERTY_COVS = ['CPBPPCov', 'CPBldgCov']

        if (!_.isUndefined(blanketCoverages)) {
            // DE16212
            if (isPolicySummary) {
                return building?.coverages.concat(blanketCoverages)
                    .filter(blgcov => (blgcov.selected || blgcov.required) &&
                        !_.includes(BUILDING_PROPERTY_COVS, blgcov.publicID))
            }
            return building.coverages.value.concat(blanketCoverages)
                .filter(blgcov => (blgcov.selected || blgcov.required) &&
                    !_.includes(BUILDING_PROPERTY_COVS, blgcov.publicID))
        }

        if (isPolicySummary) {
            return building?.coverages?.filter(blgcov => blgcov.selected || blgcov.required)
        }

        return building?.coverages.value.filter(blgcov => blgcov.selected || blgcov.required)
    }, [building]);

    const overrideProps = {
        // buildingNumber: {
        //     value: _.get(building, 'buildingNumber')
        // },
        buildingCoverages: {
            value: getCoveragesToDisplay(),
            isEditable: false,
            path: `${buildingPath}.coverages`,
            splitByClauseCategory: true,
            isCommericalCoverageScreen: true,
            isCommercialSummary: true,
            showAmount: true,
            showCoverageNameAmount: false,
            isClaimSummary: false
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={building}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default CommercialCoveragesAccordion